import React from 'react';
import { connect } from 'react-redux';
import ConsentDialog from '../../../../common/ConsentDialog';
import { Button, BUTTON_VARIANTS, Loader, IconOpenInNew, IconCheckCircle, StatusIndicator } from 'cdk-radial';
import './styles/dataRights.scss';
import { getDataRightsConsentSigningUrlQuery } from '../../../../../utils/gql';
import { client } from '../../../../../utils/apolloClient';
import { environmentURLs } from '../../../../common/CaptureEnvironment';
import {
  updateDataRightsAcceptedStatusInConsentInfo,
  updateDataRightsFlag
} from '../../../../../redux/connectedComponent/selectedLocations/selectedLocations.slice';
import { createDataRightsConsent, getUserDetails, updateDataRights } from '../../../../../redux/connectedComponent/dataRights/dataRights.slice';
import { sendAmplitudeData } from '../../../../../utils/amplitude';
import { AMPLITUDE_EVENTS,AMPLITUDE_PROPERTIES } from '../../../../../constants/amplitudeConstants';

const COLOR_STROKE = '#006CFA';
const DARK_GREEN = 'rgb(9, 173, 0)';
const LIGHT_GREEN = 'rgb(205, 240, 204)';
const DARK_GRAY = 'rgb(169, 169, 169)';
const LIGHT_GRAY = 'rgb(211, 211, 211)';

const LOADER_STYLE = {
  stroke: COLOR_STROKE,
  margin: '0px 70px'
};
const DATA_RIGHTS = 'data_rights';
const ACCEPTED = 'accepted';
const DEALER_PORTAL = 'dealerportal';
class DataRights extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isDataRightsAccepted: true,
      isDeterminingDataRightsAccepted: true,
      signingUrl: null,
      signedDocumentUrl: null
    };
    client.setTokenClient(this.props.token);
  }

  static getDerivedStateFromProps(nextProps) {
    const consentInfo = nextProps.consentInfo;

    const selectedLocations = nextProps.navigatedFromSubscriptionManagement ? nextProps.locationToAddForSubManagement : nextProps.selectedLocations;
    //wait for consents info for all the locations before determining
    if (consentInfo && selectedLocations) {
      if (Object.keys(consentInfo).length !== selectedLocations.length) {
        return {
          isDeterminingDataRightsAccepted: true
        };
      }
    }

    if(nextProps.isCheckDataRightsSignedErrored) {
      return {
        isDeterminingDataRightsAccepted: false,
        isDataRightsAccepted: false
      }
    }
    let dataRightsAccepted;
    for (var key in consentInfo) {
      if (consentInfo[key].dataRightsAccepted!==null && !consentInfo[key].dataRightsAccepted) return null;
      if (key && consentInfo[key].dataRightsAccepted !== 'Yes') {
        nextProps.updateDataRightsFlag(false)
        return {
          isDeterminingDataRightsAccepted: false,
          isDataRightsAccepted: false
        };
      } else {
        dataRightsAccepted = true;
      }
    }
    nextProps.updateDataRightsFlag(dataRightsAccepted)
    return {
      isDeterminingDataRightsAccepted: false,
      isDataRightsAccepted: dataRightsAccepted
    };
  }

  Id() {
    return Math.random()
      .toString(36)
      .substr(2, 9);
  }

  today = () => {
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = today.getFullYear();
    return mm + '/' + dd + '/' + yyyy;
  };

  getDataRightsConsentSigningUrl = async () => {
    try {
      let email = this.props.userInfo.uid;
      let dataRightsConsentSigningUrl = await client.apolloClient.query({
        query: getDataRightsConsentSigningUrlQuery,
        variables: {
          id: this.Id(),
          firstName: this.props.userInfo.firstName,
          lastName: this.props.userInfo.lastName,
          email: email,
          date: this.today(),
          redirectUrl: environmentURLs.SIGNING_REDIRECT_URL,
          emailForBusinessRole: this.props.userInfo.uid
        }
      });

      if (
        !dataRightsConsentSigningUrl ||
        !dataRightsConsentSigningUrl.data ||
        !dataRightsConsentSigningUrl.data.dataRightsConsentSigningUrl ||
        !dataRightsConsentSigningUrl.data.dataRightsConsentSigningUrl.links ||
        typeof !dataRightsConsentSigningUrl.data.dataRightsConsentSigningUrl
          .links === Array ||
        !dataRightsConsentSigningUrl.data.dataRightsConsentSigningUrl.links
          .length > 0
      ) {
        console.error('error in response of dataRightsConsentSigningUrl query');
      }
      const url =
        dataRightsConsentSigningUrl.data.dataRightsConsentSigningUrl.links[0]
          .href;
      const signedDocumentUrl =
        dataRightsConsentSigningUrl.data.dataRightsConsentSigningUrl.links[1]
          .href;

      this.setState({
        signingUrl: url,
        signedDocumentUrl: signedDocumentUrl
      });
    } catch (e) {
      console.error(e);
    }
  };

  dataRightsAgreementAccepted = async () => {
    let consentInfo = this.props.consentInfo;
    const solutionId = 'dataRights-id';
    const listingVersion = '0';
    const token = this.props.token;
    var entityList = [];
    for (var entityId in consentInfo) {
      if (
        entityId
        && consentInfo[entityId].dataRightsAccepted
        && consentInfo[entityId].dataRightsAccepted !== 'Yes'
      ) {
        entityList.push({entityId, cmfNumber: consentInfo[entityId].cmfNumber});
      }
    }
    let cmfNumbers = []
    this.props.selectedLocationsWithCMFNumber.forEach(entity => { cmfNumbers.push(entity.cmfNumber) });
    this.props.updateDataRights({ cmfNumbers, token })
    this.props.updateDataRightsAcceptedStatusInConsentInfo();

    if (entityList.length){
      let firstName = this.props.userInfo && this.props.userInfo.firstName;
      let lastName = this.props.userInfo && this.props.userInfo.lastName;
      let consentPayload = {
        entityList: entityList,
        solutionId: solutionId,
        signedTermsAndConditions: this.props.preloadedDataRights.split('?')[0],
        status: ACCEPTED,
        apiProviderId: 'NA',
        consentType: DATA_RIGHTS,
        consentedSource: DEALER_PORTAL,
        listingVersion: listingVersion,
      };


      let loggedInUserEmail = this.props.userInfo && this.props.userInfo.sub;

      let businessRoleData = await this.props.getUserDetails({
        loggedInUserEmail,
        firstName,
        lastName,
        token
      });

      if(businessRoleData && businessRoleData.payload && businessRoleData.payload.data){
        businessRoleData.payload.data.dealershipName = Object.values(consentInfo).map(ci => ci.location).join();
        consentPayload.businessRoleData = businessRoleData.payload.data;
      }

      await this.props.createDataRightsConsent({
        consentPayload,
        solutionId,
        listingVersion,
        token
      });

      const { selectedLocationsWithCMFNumber, appName, appId } = this.props;

      sendAmplitudeData(AMPLITUDE_EVENTS.ACCEPTED_DATA_RIGHTS, {
        [AMPLITUDE_PROPERTIES.APP_NAME]:  appName,
        [AMPLITUDE_PROPERTIES.APP_ID]:  appId,
        [AMPLITUDE_PROPERTIES.LOCATION_COUNT]: selectedLocationsWithCMFNumber?.length,
        [AMPLITUDE_PROPERTIES.LOCATIONS]: selectedLocationsWithCMFNumber?.map(
          (loc) => ({
            [AMPLITUDE_PROPERTIES.ORG_ID]: loc?.entityId,
            [AMPLITUDE_PROPERTIES.ORG_NAME]: loc?.location,
            [AMPLITUDE_PROPERTIES.ORG_CMF]: loc?.cmfNumber,
          })
        ),
      });
    }
  };

  render() {
    const { appName, providerName, appId } = this.props;
    return (
      <div className="data-rights-container">
        <div className="data-rights-header">
          <div className="data-rights-header-title">CDK data rights</div>
          <div className="data-rights-header-description">
            One-time consent required before connecting Fortellis apps to your
            CDK DMS.
          </div>
        </div>
        <div className="data-rights-body">
          <div>
            <div className="data-rights-body-title">Data Rights Consent</div>
            <div className="data-rights-body-description">CDK Global</div>
          </div>
          <div className="data-rights-body-review-terms-container">
            <div className="data-rights-body-review-terms">
              {
              this.props.checkDataRightsErroredEntityIds?.length ?
                <StatusIndicator
                  backgroundColor={LIGHT_GRAY}
                  borderColor={DARK_GRAY}
                  iconColor={DARK_GREEN}
                  label="Failed to load data"
                  variant="custom"
                /> :
              this.state.isDeterminingDataRightsAccepted ||
              this.props.isCheckDataRightsSignedPending ? (
                <Loader style={LOADER_STYLE} />
              ) : this.state.isDataRightsAccepted ? (
                <StatusIndicator
                  backgroundColor={LIGHT_GREEN}
                  borderColor={DARK_GREEN}
                  icon={<IconCheckCircle />}
                  iconColor={DARK_GREEN}
                  label="Terms accepted"
                  variant="custom"
                />
              ) : (
                <Button
                  backgroundAppearance="light"
                  customTagElement=""
                  dataTestId="button"
                  hideText={false}
                  iconClassName=""
                  iconColor="primary"
                  iconSize={28}
                  isDisabled={false}
                  isLoading={false}
                  loaderText="Loading..."
                  onClick={() => {
                    this.setState({
                      openConsentDialog: true
                    });
                    // this.getDataRightsConsentSigningUrl();
                  }}
                  onKeyDown={function noRefCheck() {}}
                  preserveClickableArea={false}
                  size="standard"
                  icon={<IconOpenInNew />}
                  text="Review Terms"
                  type=""
                  variant={BUTTON_VARIANTS.SECONDARY}
                />
              )}
            </div>
          </div>
        </div>
        {this.state.openConsentDialog && (
          <ConsentDialog
            type={'Data Rights Consent'}
            consentType={'Data Rights Consent'}
            open={true}
            onAccept={() => {
              this.setState({
                openConsentDialog: false
              });
            }}
            onClose={() => {
              this.setState({
                openConsentDialog: false,
                signingUrl: null,
                signedDocumentUrl: null
              });
            }}
            userInfo={{
              firstName: this.props.userInfo && this.props.userInfo.firstName,
              lastName: this.props.userInfo && this.props.userInfo.lastName
            }}
            email={this.props.userInfo && this.props.userInfo.uid}
            signingUrl={this.state.signingUrl}
            signedDocumentUrl={this.state.signedDocumentUrl}
            dataRightsAgreementAccepted={this.dataRightsAgreementAccepted}
            token={this.props.token}
            appName={appName}
            providerName={providerName}
            appId={appId}
            docUrl={this.props.preloadedDataRights}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  isCheckDataRightsSignedPending:
    state &&
    state.selectLocationsSlice &&
    state.selectLocationsSlice.isCheckDataRightsSignedPending,
  isCheckDataRightsSignedErrored:
    state &&
    state.selectLocationsSlice &&
    state.selectLocationsSlice.isCheckDataRightsSignedErrored,
  checkDataRightsErroredEntityIds:
    state &&
    state.selectLocationsSlice &&
    state.selectLocationsSlice.checkDataRightsErroredEntityIds,
  consentInfo:
    state &&
    state.selectLocationsSlice &&
    state.selectLocationsSlice.consentInfo,
  dataRightsLocationsToConsent:
    state &&
    state.selectLocationsSlice &&
    state.selectLocationsSlice.dataRightsLocationsToConsent,
  selectedLocations:
    state &&
    state.selectLocationsSlice &&
    state.selectLocationsSlice.selectedLocations,
  userInfo:
    state && state.loginDetailsSlice && state.loginDetailsSlice.decodedToken,
  token:
    state &&
    state.loginDetailsSlice &&
    state.loginDetailsSlice.authenticationToken,
  appName:
    state &&
    state.solutionInfoSlice &&
    state.solutionInfoSlice.solutionInfo.overview &&
    state.solutionInfoSlice.solutionInfo.overview.name,
  providerName:
    state &&
    state.solutionInfoSlice &&
    state.solutionInfoSlice.solutionInfo &&
    state.solutionInfoSlice.solutionInfo.organizationName,
  appId:
    state &&
    state.solutionInfoSlice &&
    state.solutionInfoSlice.solutionInfo &&
    state.solutionInfoSlice.solutionInfo.id,
  preloadedDataRights :
    state &&
    state.solutionInfoSlice &&
    state.solutionInfoSlice.preloadedDataRights,
  selectedLocationsWithCMFNumber :
    state &&
    state.selectLocationsSlice &&
    state.selectLocationsSlice.selectedLocationsWithCMFNumber
});

const mapDispatchToProps = {
  updateDataRightsAcceptedStatusInConsentInfo,
  updateDataRightsFlag,
  createDataRightsConsent,
  getUserDetails,
  updateDataRights
};

export default connect(mapStateToProps, mapDispatchToProps)(DataRights);
